(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["central-de-atendimento"] && !Shopify.designMode) return;
  try {
    
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function(){dataLayer.push(arguments);};

document.addEventListener('DOMContentLoaded', function(){
  // Evento de visualização do hub
  if (typeof gtag === 'function') {
    gtag('event', 'contact_hub_view', {
      event_category: 'support',
      event_label: 'central_de_atendimento',
      non_interaction: true
    });
  }

  // Click nos canais
  document.querySelectorAll('[data-channel]').forEach(function(el){
    el.addEventListener('click', function(){
      var channel = el.getAttribute('data-channel') || 'unknown';
      if (typeof gtag === 'function') {
        gtag('event', 'contact_channel_click', {
          event_category: 'support',
          event_label: channel,
          channel: channel
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hana-product-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hana-rich-description]').forEach((description) => {
    if (description.dataset.enhanced === 'true') return;
    const nodes = Array.from(description.children);
    const firstHeading = nodes.findIndex((node) => /^H[23]$/.test(node.tagName));
    if (firstHeading < 0) return;

    const fragment = document.createDocumentFragment();
    if (firstHeading > 0) {
      const lead = document.createElement('div');
      lead.className = 'hana-product-story__lead';
      nodes.slice(0, firstHeading).forEach((node) => lead.appendChild(node));
      fragment.appendChild(lead);
    }

    let chapter;
    nodes.slice(firstHeading).forEach((node) => {
      if (/^H[23]$/.test(node.tagName)) {
        chapter = document.createElement('section');
        chapter.className = 'hana-product-story__chapter';
        fragment.appendChild(chapter);
      }
      chapter?.appendChild(node);
    });

    description.replaceChildren(fragment);
    description.classList.add('is-enhanced');
    description.dataset.enhanced = 'true';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hana-rebuild-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hana-navigation]').forEach((navigation) => {
    const closeItems = (except) => {
      navigation.querySelectorAll('.hana-rebuild-header__nav-item.is-open').forEach((item) => {
        if (item === except) return;
        item.classList.remove('is-open');
        item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
      });
    };
    navigation.querySelectorAll('.hana-rebuild-header__nav-label > button').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.hana-rebuild-header__nav-item');
        const willOpen = !item.classList.contains('is-open');
        closeItems(item);
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });
    navigation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeItems();
    });
    document.addEventListener('click', (event) => {
      if (!navigation.contains(event.target)) closeItems();
    });
  });

  document.querySelectorAll('[data-hana-mobile-benefits]').forEach((track) => {
    const benefits = Array.from(track.querySelectorAll('.hana-rebuild-header__benefit'));
    if (benefits.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let current = 0;
    window.setInterval(() => {
      if (!window.matchMedia('(max-width: 749px)').matches || document.hidden) return;
      benefits[current].classList.remove('is-active');
      current = (current + 1) % benefits.length;
      benefits[current].classList.add('is-active');
    }, 4200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hana-rebuild-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hana-hero-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-hana-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('.hana-rebuild-hero__dots button'));
    if (slides.length < 2) return;
    let current = 0;
    const show = (index) => { slides[current].classList.remove('is-active'); dots[current]?.classList.remove('is-active'); current = index; slides[current].classList.add('is-active'); dots[current]?.classList.add('is-active'); };
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) window.setInterval(() => { if (!document.hidden) show((current + 1) % slides.length); }, 6500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
